import { render } from "./clock.vue?vue&type=template&id=3f6524e5"
import script from "./clock.vue?vue&type=script&lang=js"
export * from "./clock.vue?vue&type=script&lang=js"

import "./clock.vue?vue&type=style&index=0&id=3f6524e5&lang=less"

import exportComponent from "E:\\05projects\\fullstack\\who-clicked-clock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__